module.exports = __webpack_public_path__ + "img/mobile-feed.26f2b4a6.svg";